import { create } from 'zustand'

import { CURRENT_BUILD_ID } from '@/utils'

type BuildVersionState = {
  isStale: boolean
  latestBuildId: string | null
  setLatestBuildId: (buildId: string) => void
}

export const useBuildVersionStore = create<BuildVersionState>((set) => ({
  isStale: false,
  latestBuildId: null,
  setLatestBuildId: (buildId) =>
    set({ isStale: buildId !== CURRENT_BUILD_ID, latestBuildId: buildId }),
}))
